/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { TaskMessageTypeMap } from './TaskMessageConfig';
import { Message } from './messageTypes';

const styles = StyleSheet.create({
  messages: {
    marginBottom: 24,
  },
});

// TODO: set form aria-labelledby to TASK_MESSAGE_CONTAINER_ID
export const TASK_MESSAGE_CONTAINER_ID = `taskMessages`;

export namespace TaskMessages {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    messages: Message[];
  }
}

export const TaskMessages: React.FC<TaskMessages.Props> = ({ messages }) => {
  return (
    <div className={css(styles.messages)} id={TASK_MESSAGE_CONTAINER_ID}>
      {messages.map(message => {
        const TaskMessage = TaskMessageTypeMap[message.type];
        return <TaskMessage key={message.display} message={message} />;
      })}
    </div>
  );
};
